// Access rarely changes, so the shared client's seconds-long default would refetch constantly. A write that
// changes access, or a 403, invalidates the answers straight away; expiry only catches a change neither saw.
export const AUTHZ_FRESHNESS_MS = 5 * 60 * 1000
